// removed by extract-text-webpack-plugin
module.exports = {"background":"AreaChip__background__2qfRm"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Common/Chip/AreaChip.scss
// module id = 1637
// module chunks = 0